export const FrontUserStore = {
    namespaced: true,
    state: {
        id: $('#auth-id').val(),
        corporate_id: $('#auth-corporate_id').val(),
        branch_id: $('#auth-branch_id').val(),
        industry_type: $('#auth-industry_type').val(),
    }
};